/**
 * Region-change warning policy for registration.
 * Compares stored CurrentRegion to the new country — never inspects API URLs.
 */

/** Effective country for SetCountry: fixed environment.countryCode always wins when set. */
export function resolveCountryCodeForBuild(
  requestedCountryCode: string | null | undefined,
  fixedCountryCode: string | null | undefined,
): string {
  const fixed = (fixedCountryCode ?? '').trim().toLowerCase();
  if (fixed.length > 0) {
    return fixed;
  }
  return (requestedCountryCode ?? '').trim().toLowerCase();
}

/** Whether a registration region switch should show a warning (not an error / logout). */
export function shouldWarnAboutRegionChange(options: {
  isLoggedIn: boolean;
  fixedCountryCode: string | null | undefined;
  previousCountryCode: string | null | undefined;
  newCountryCode: string | null | undefined;
}): boolean {
  if (!options.isLoggedIn) {
    return false;
  }
  const fixed = (options.fixedCountryCode ?? '').trim();
  if (fixed.length > 0) {
    return false;
  }
  const previous = (options.previousCountryCode ?? '').trim().toLowerCase();
  const next = (options.newCountryCode ?? '').trim().toLowerCase();
  if (!previous || !next) {
    return false;
  }
  return previous !== next;
}
